import styled from "styled-components";

export const StyledProfileDetails = styled.div`
	margin-top: 1.6rem;
	header {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-template-rows: auto auto auto;
		justify-items: flex-start;
		column-gap: 2.4rem;
		row-gap: 0.8rem;
		picture {
			grid-row: 1 / -1;
		}
		h1 {
			margin-top: 0;
		}
	}
`;
